import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-campaign-builder',
  templateUrl: './view-campaign-builder.component.html',
  styleUrls: ['./view-campaign-builder.component.css']
})
export class ViewCampaignBuilderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
